// This files handles injecting geo info into all species

import DataLayer from '@/store/MiscDataLayer'
import _groupBy from 'lodash/groupBy'
import _intersectionWith from 'lodash/intersectionWith'
import _merge from 'lodash/merge'
import _values from 'lodash/values'
import _keyBy from 'lodash/keyBy'

const fetchGeoInfo = () => {
  return new Promise((resolve, reject) => {
    DataLayer.GetSpecGeo()
      .then(res => {
        resolve(res.data)
      })
      //TODO: needs better error-handling
      .catch(e => {
        console.log(e)
        reject()
      })
  })
}

const svenskaLanOstKust = [
  'bd',
  'ac',
  'y',
  'x',
  'c',
  'ab',
  'd',
  'e',
  'i',
  'h',
  'k',
  'm'
]
const svenskaLanVastKust = ['n', 'o']

export default function(allSpecies) {
  return new Promise((resolve, reject) => {
    fetchGeoInfo()
      .then(geoInfo => {
        let newGroup = []
        let ids = []
        // Group by species id
        const speciesGroups = _groupBy(geoInfo, 'spec_id')
        for (const key in speciesGroups) {
          ids = []
          speciesGroups[key].forEach(row => {
            ids.push(row.init)
          })
          newGroup.push({
            id: parseInt(key),
            areas: ids,
            ost: false,
            vast: false
          })
        }
        newGroup.forEach(row => {
          if (_intersectionWith(row.areas, svenskaLanOstKust).length > 0) {
            row.ost = true
          }
          if (_intersectionWith(row.areas, svenskaLanVastKust).length > 0) {
            row.vast = true
          }
        })
        allSpecies.forEach(s => {
          s.areas = []
          s.ost = false
          s.vast = false
          let id = s.id
          let injectInfo = newGroup.find(g => g.id === s.id)
          if (injectInfo) {
            s.areas = injectInfo.areas
            s.ost = injectInfo.ost
            s.vast = injectInfo.vast
          }
        })
        resolve(allSpecies)
      })
      //TODO: needs better error-handling
      .catch(e => {
        console.log(e)
        reject(e)
      })
  })
}
